/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermissionTypeEnum } from '../../models/permission-type-enum';

export interface DeleteMenuSectionPermissions$Params {

/**
 * ID sekcie
 */
  id: number;

/**
 * ID oprávnenia
 */
  permissionId: number;

/**
 * typ oprávnenia (PRODUCT/COMPANY)
 */
  permissionType: PermissionTypeEnum;
}

export function deleteMenuSectionPermissions(http: HttpClient, rootUrl: string, params: DeleteMenuSectionPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, deleteMenuSectionPermissions.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('permissionId', params.permissionId, {});
    rb.query('permissionType', params.permissionType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

deleteMenuSectionPermissions.PATH = '/admin/menu/{id}/permissions/{permissionId}';
